import styled from 'styled-components'

export const NewSiteHeader = styled.div`
  height: 72px;
  padding: 0 32px;
  display: flex;
  position: fixed;
  width: 100vw;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 1px 2px rgba(32, 32, 32, 0.1);
  background: #ffffff;
  z-index: 10000;
`

export const NewSiteHeaderTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`

export const NewSiteHeaderTooltip = styled.div`
  height: 16px;
  width: 16px;

  :hover {
    path {
      fill-opacity: 1;
    }
  }
`

export const NewSiteHeaderManageUserWrapper = styled(NewSiteHeaderTitleWrapper)`
  justify-content: flex-end;
`

export const NewSiteHeaderTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 32px;
`

export const NewSiteHeaderStatusIcon = styled.div`
  height: 8px;
  width: 8px;
  margin-left: 24px;
  margin-right: 8px;
  border-radius: 50%;
  background: ${(p) => {
    return p.color
  }};
`

export const NewSiteHeaderUsersIcons = styled.div`
  width: ${(p) => {
    return p.width
  }};
  cursor: pointer;
`

export const NewSiteHeaderNotification = styled.div`
  flex-shrink: 0;
  height: 40px;
  width: 100%;
  position: sticky;
  padding: 0 32px;
  top: 72px;
  left: 0;
  background: #202020;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  z-index: 6;
  margin: 0;

  path {
    fill: #ffffff;
  }

  div {
    cursor: pointer;
  }
`

export const NewSiteHeaderStatusWrapper = styled.div`
  font-size: 12px;
  line-height: 16px;
  font-weight: 500;
  color: rgba(32, 32, 32, 0.7);
  margin-right: 8px;
`

export const NewSiteHeaderDropdownIconWrapper = styled.div`
  height: 24px;
  width: 24px;
  position: relative;
  cursor: pointer;

  path {
    fill-opacity: ${(p) => {
      return p.isActive ? '1' : '0.5'
    }};
  }

  :hover {
    path {
      fill-opacity: 1;
    }
  }
`

export const NewSiteHeaderDropdownMenu = styled.div`
  /* Layout & Sizing */
  display: ${(p) => (p.isActive ? 'flex' : 'none')};
  flex-direction: column;
  width: 265px;
  max-height: 420px;
  min-height: 72px;
  position: absolute;
  top: 64px;
  right: 0;
  z-index: 6;
  padding: 8px 0 8px 16px;
  align-items: flex-start;
  justify-content: flex-start;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid rgba(32, 32, 32, 0.1);
  box-shadow: 0 4px 12px rgba(32, 32, 32, 0.08);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(32, 32, 32, 0.1);
    border-radius: 10px;
  }
`
export const ProfileIconDiv = styled.div`
  margin: 8px 0;
`
export const ButtonWrapper = styled.div`
  margin-left: 12px;
  cursor: pointer;
`